module.exports = "<div class=\"login-body\">   \n    <!-- <main class=\"main\"> -->\n        <!-- <div class=\"container-fluid\"> -->\n            <router-outlet></router-outlet>\n        <!-- </div> -->\n    <!-- </main> -->\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/login-layout/login-layout.component.html
// module id = ../../../../../src/app/views/login-layout/login-layout.component.html
// module chunks = main